import React from 'react';
import { Box } from '@mui/material';
import EventCard from './EventCard';

type Event = {
    id: number;
    title: string;
    image: string;
    venue: string;
    date: string;
    time: string;
    price: number;
    isFreeOfCharge: boolean;
};

type Props = {
    events: Event[];
};

const EventsBox: React.FC<Props> = ({ events }) => (
    <Box
        sx={{
            display: 'flex',
            overflowX: 'auto',
            gap: 2,
            paddingBottom: 2,
            paddingTop: 2,
            '&::-webkit-scrollbar': { display: 'none' }, // Hide scrollbar for Webkit browsers
            '-ms-overflow-style': 'none', // Hide scrollbar for IE and Edge
            'scrollbar-width': 'none' // Hide scrollbar for Firefox
        }}
    >
        {events.map((event) => (
            <Box key={event.id} sx={{ flex: '0 0 auto', width: '250px' }}>
                <EventCard event={event} />
            </Box>
        ))}
    </Box>
);

export default EventsBox;
